import { isNullOrWhitespace } from "../../../../common/stringOperations";

export class FrameworkTemplateControlLanguageModel {
    constructor(name: string, description: string | undefined, twoLetterIsoLanguage: string) {
        this.name = name;
        this.description = description;
        this.twoLetterIsoLanguage = twoLetterIsoLanguage;
    }

    name: string;
    description: string | undefined;
    twoLetterIsoLanguage: string;
}
export class FrameworkTemplateControlSaveModel {
    customId: string | undefined;
    categoryId: string;
    implementationGroup: string | undefined;
    annualWheelActivities: Array<string> = [];
    languages: Array<FrameworkTemplateControlLanguageModel> = [];

    constructor(
        customId: string | undefined,
        categoryId: string,
        annualWheelActivities: Array<string>,
        languages: Array<FrameworkTemplateControlLanguageModel> = [],
        implementationGroup: string | undefined
    ) {
        this.languages = languages;
        this.customId = customId;
        this.categoryId = categoryId;
        this.annualWheelActivities = annualWheelActivities;
        this.implementationGroup = implementationGroup;
    }

    static createDefault() {
        return new FrameworkTemplateControlSaveModel(
            "",
            "",
            [],
            [new FrameworkTemplateControlLanguageModel("", undefined, "en"), new FrameworkTemplateControlLanguageModel("", undefined, "da")],
            undefined
        );
    }

    withUpdates(updates: Partial<FrameworkTemplateControlSaveModel>): FrameworkTemplateControlSaveModel {
        return new FrameworkTemplateControlSaveModel(
            updates.customId ?? this.customId,
            updates.categoryId ?? this.categoryId,
            updates.annualWheelActivities ?? this.annualWheelActivities,
            updates.languages ?? this.languages,
            updates.implementationGroup ?? this.implementationGroup
        );
    }

    isInvalid() {
        return this.isNameInvalid() || this.isCategoryInvalid();
    }

    isNameInvalid() {
        return this.languages.some((language) => isNullOrWhitespace(language.name));
    }

    isCategoryInvalid() {
        return isNullOrWhitespace(this.categoryId);
    }

    withNewName(lang: string, name: string | undefined) {
        this.languages.find((l) => l.twoLetterIsoLanguage === lang)!.name = name ?? "";
        return this.withUpdates({ languages: this.languages });
    }

    withNewDescription(lang: string, description: string | undefined) {
        this.languages.find((l) => l.twoLetterIsoLanguage === lang)!.description = description;
        return this.withUpdates({ languages: this.languages });
    }
}
